import { Button, Card, Page, Text, TextField } from "@shopify/polaris";
import { loadStripe } from "@stripe/stripe-js";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Balance } from "../context/Context";

export const formatCurrency = (payAmount, currency) => {
  switch (currency.toLowerCase()) {
    case "eur":
    case "gbp":
    case "usd":
    case "aed":
    case "cad":
    case "sgd":
    case "chf":
    case "zar":
    case "cny":
      return Number(payAmount);
    default:
      break;
  }
};
export default function EnterBalance() {
  const { setAmount, storeID, setClientSecret, setStripePromise } = Balance();
  const navigate = useNavigate();

  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);

  if (!storeID) {
    return <Navigate to={"/not-found"} />;
  }

  const goToCheckout = async () => {
    setLoading(true);

    setAmount(balance);
    const amount = formatCurrency(balance, "gbp");
    const checkoutData = {
      currencyCode: "gbp",
      amount: amount,
    };

    const response = await fetch(
      "https://backend.wecarrybags.co.uk/api/v1/customer/create-payment-intent",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(checkoutData),
      },
    );
    const STRIPE_PUBLIC_KEY =
      "pk_live_51KNnCIBPkmVpEEUIo2wJ82vDEO8bEWhPBCGAxvTeF0SOwEBvOMoy4bwTBpkjvtDc33bdClqAzqbiY9xiUhkVOXlv00VyYvlf7L";

    const data = await response.json();

    const clientSecret = data.clientSecret;
    const stripePromise = await loadStripe(STRIPE_PUBLIC_KEY);
    setClientSecret(clientSecret);
    setStripePromise(stripePromise);

    navigate("/checkout");
  };

  return (
    <Page>
      <Card>
        <Text variant="headingMd">Enter Balance</Text>
        <div style={{ padding: 3 }} />
        <Text>
          Enter the amount you would like to top up by, in whole pounds, below.
        </Text>
        <TextField
          type="number"
          value={balance}
          onChange={(balance) => setBalance(Number(balance))}
        />
        <div style={{ display: "flex", flexDirection: "row-reverse" }}>
          <Button
            id="submit"
            onClick={() => goToCheckout()}
            disabled={loading || balance < 0.3}
          >
            Proceed to payment
          </Button>
        </div>
      </Card>
    </Page>
  );
}
